<template>
  <!--弹框1 开始-->
  <el-dialog :visible.sync="frameDialog" top="35vh" :close-on-click-modal="showClo" :close-on-press-escape="showClo" :width="frameWidth" :show-close="showClo" center style="text-align: center;">
    <div style="width:100%;text-align: center;">
      <div><img src="https://res.roompai.com/static/img/frame/refresh-11.png" class="frame-small-img" @click="refresh"></div>
      <div class="frame-text wordBreak">{{$t('confirmingPrice')}}</div>
    </div>
  </el-dialog>
  <!--弹框1 结束-->
  <!--引入方式-->
  <!-- <frameRefresh :frameDialog="frameDialog"></frameRefresh> -->
</template>

<script>
export default {
  name: 'frameRefresh',
  props: ['frameDialog'],
  data () {
    return {
      frameWidth: '450px',
      showClo: false
    }
  },
  mounted () {
    if (document.body.clientWidth < 1001) {
      this.frameWidth = '95%'
    } else {
      this.frameWidth = '450px'
    }
  },
  methods: {
    refresh () {
      location.reload()
      this.frameDialog = false
      this.frameRiseDialog = false
    }
  }
}
</script>

<style scoped>
.frame-small-img{width:80px; height:80px;cursor: pointer;}
.frame-text{height:74px; line-height: 74px;font-size: 16px;color: #4F4C4C;text-align: center;}
@media screen and (max-width: 1000px) {
.dialog-goon,.dialog-goback{width:100%; margin-bottom: 10px;}
}
</style>



// WEBPACK FOOTER //
// src/components/public/frameRefresh.vue